// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f3f67fc0","318":"8686cbea","439":"f7e4b5f3","488":"4fefe141","820":"7d681c9a"}[chunkId] + ".chunk.js";
};